"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _runtime = require("../runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = (0, _runtime.IconWrapper)('speed', function (props) {
  return _react.default.createElement("svg", {
    width: props.size,
    height: props.size,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, _react.default.createElement("g", {
    stroke: "none",
    strokeWidth: props.strokeWidth,
    fill: "none",
    fillRule: "evenodd"
  }, _react.default.createElement("g", null, _react.default.createElement("path", {
    d: "M34.0234142,6.68920943 C31.0763953,4.97911987 27.6525405,4 24,4 C12.954305,4 4,12.954305 4,24 C4,35.045695 12.954305,44 24,44 C35.045695,44 44,35.045695 44,24 C44,20.3726952 43.034363,16.9709271 41.3461313,14.0377377",
    stroke: props.outStrokeColor,
    strokeWidth: props.strokeWidth,
    strokeLinecap: props.strokeLinecap,
    strokeLinejoin: props.strokeLinejoin
  }), _react.default.createElement("path", {
    d: "M26.6464466,28.8535534 C29.3131133,22.9929794 30.6464466,19.3263127 30.6464466,17.8535534 C30.6464466,15.6444144 28.8555856,13.8535534 26.6464466,13.8535534 C24.4373076,13.8535534 22.6464466,15.6444144 22.6464466,17.8535534 C22.6464466,19.3263127 23.9797799,22.9929794 26.6464466,28.8535534 Z",
    stroke: props.outStrokeColor,
    strokeWidth: props.strokeWidth,
    fill: props.outFillColor,
    fillRule: "nonzero",
    strokeLinejoin: props.strokeLinejoin,
    transform: "translate(26.646447, 21.353553) scale(1, -1) rotate(-45.000000) translate(-26.646447, -21.353553) "
  }))));
});

exports.default = _default;